<template>
  <div class="py-md-5 py-4">
    <div class="text-center mb-5">
      <h3>Reset Password</h3>
      <p class="text-muted">Reset Password with Doot.</p>
    </div>
    <div class="alert alert-info text-center my-4" role="alert">
      Enter your Email and instructions will be sent to you!
    </div>
    <form>
      <div class="mb-3">
        <label for="email" class="form-label">Email address</label>
        <input type="email" class="form-control" id="email" v-model="email" />
      </div>

      <div class="text-center mt-4">
        <button
          v-if="emailIsCorrect"
          type="submit"
          class="btn btn-primary w-100"
          @click="forgotpassword"
        >
          Reset
        </button>
        <button
          v-else
          type="submit"
          class="btn btn-primary w-100 disabled"
          disabled
        >
          Reset
        </button>
      </div>
    </form>
    <!-- end form -->

    <div class="mt-5 text-center text-muted">
      <p>
        Remember It ?
        <router-link :to="{ name: 'Signin' }" custom v-slot="{ navigate }">
          <a
            role="link"
            @click="navigate"
            class="fw-medium text-decoration-underline"
            @keypress.enter="navigate"
          >
            Login
          </a>
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForgotPassword",

  data() {
    return {
      email: "",
      emailIsCorrect: false,
    };
  },

  watch: {
    email() {
      const val = this.$store.state.utils.filters.validateEmail(this.email);
      this.emailIsCorrect = val;
    },
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {
    forgotpassword() {
      event.preventDefault();
      if (this.emailIsCorrect) {
        this.$store.state.modules.api
          .forgotpassword(this.email)
          .then((resp) => {
            this.email = "";
            if (resp.status === 200) {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "success",
                  message: "Verification email has been sent",
                },
                2500
              );

              this.$router.push({ name: "Home" });
            } else {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "warning",
                  message: "Check the entries are correct",
                },
                2500
              );
            }
          })
          .catch((e) => {});
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: "The email is incorrect!",
          },
          2500
        );
      }
    },
  },
};
</script>
